export default "__VITE_ASSET__CNO$T1vd__"